import React from 'react';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';
import { OnwardTab, OnwardTabContainer } from '@/components/Tabs';
import { STAGES, STAGE_DISPLAY_MAPPINGS } from './constants';

const StatusFilter = ({ state, callbacks }) => {
    return (
        <Grid
            direction="row"
            container
            css={css`
                display: flex;
                background-color: white;
            `}
        >
            <Grid
                direction="column"
                container
                css={css`
                    flex: 1;
                    flex-basis: 0;
                    align-content: center;
                `}
            >
                <OnwardTabContainer
                    value={state.filter.stage}
                    onChange={(e, t) => {
                        callbacks.setFilter((prev) => {
                            return {
                                ...prev,
                                stage: t,
                            };
                        });
                    }}
                    textColor="primary"
                    indicatorColor="primary"
                >
                    {Object.keys(STAGES).map((key) => {
                        return <OnwardTab key={key} label={STAGE_DISPLAY_MAPPINGS[key]} value={key} />;
                    })}
                </OnwardTabContainer>
            </Grid>
        </Grid>
    );
};

export default StatusFilter;
